import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHeatExchangerFinnedTubesFan = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 100,
	height: 100,
	viewBox: "0 0 100.0 100.0",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 0,
			y: 0,
			width: 100,
			height: 100,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 40.0 75.0 L 40.0 85.0 M 60.0 75.0 L 60.0 85.0 M 70.0 75.0 L 70.0 85.0 M 50.0 75.0 L 50.0 85.0 M 30.0 75.0 L 30.0 85.0 M 15.0 80.0 L 85.0 80.0 M 60.0 12.0 L 71.0 48.0 M 40.0 12.0 L 29.0 48.0",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 50,
			cy: 35,
			rx: 25,
			ry: 25,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		})
	]
});
export default SvgHeatExchangerFinnedTubesFan;
